import React, { useState } from 'react';
import AppLayout from '../../component/appLayout';
import Navbar from '../../component/navbar';

const ResponsiveNavbar: React.FC = () => {
  // State variable
  const [openContactUsModal, setOpenContactUsModal] = useState(false);

  return (
    <>
      <AppLayout>
        <Navbar setOpenContactUsModal={() => setOpenContactUsModal(!openContactUsModal)} />
      </AppLayout>
    </>
  );
};

export default ResponsiveNavbar;
